import { collections } from "@/mocks/home";
import Reveal from "./Reveal";

export default function Collections() {
  return (
    <section id="collections" className="section-anchor bg-background-50 py-14 md:py-20">
      <div className="container-gua">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-archive-2-line"></i>
              合集汇总帖
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              分类合集，历史记录全收录
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              每一份合集都经过编辑部反复核对与持续补档，把散落在各处的经典内容整理成册，省去你来回翻找的麻烦。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((col, idx) => (
            <Reveal key={col.id} delay={(idx % 3) * 60}>
              <article className="group h-full overflow-hidden rounded-lg border border-background-200/70 bg-background-100/50 transition hover:border-accent-300">
                <div className="relative h-44 w-full overflow-hidden">
                  <img
                    src={col.image}
                    alt={col.title}
                    title={`${col.title} · 呱呱爆料合集`}
                    className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-md bg-black/45 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
                    {col.category}
                  </span>
                  <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                    <i className="ri-file-list-3-line"></i>
                    {col.count} 篇
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg font-bold text-foreground-900">
                    {col.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{col.desc}</p>
                  <a
                    href="#download"
                    className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 transition hover:text-primary-700"
                  >
                    查看合集
                    <i className="ri-arrow-right-line transition group-hover:translate-x-0.5"></i>
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}